export default __webpack_public_path__ + "static/media/day-night.670bf5e8.png";